export interface DeduperOptions {
  windowMs: number;
  cleanupMultiplier?: number;
}

/**
 * Tracks recently seen identifiers and rejects repeats within a configurable cooldown window.
 */
export class CooldownDeduper {
  private readonly seen = new Map<string, number>();
  private readonly windowMs: number;
  private readonly cleanupWindow: number;

  constructor(options: DeduperOptions) {
    this.windowMs = options.windowMs;
    this.cleanupWindow = this.windowMs * (options.cleanupMultiplier ?? 4);
  }

  shouldAccept(key: string, timestamp = Date.now()): boolean {
    const lastSeen = this.seen.get(key);
    if (lastSeen !== undefined && timestamp - lastSeen < this.windowMs) {
      return false;
    }
    this.seen.set(key, timestamp);
    this.cleanup(timestamp);
    return true;
  }

  clear(): void {
    this.seen.clear();
  }

  private cleanup(now: number): void {
    for (const [key, lastSeen] of this.seen) {
      if (now - lastSeen > this.cleanupWindow) {
        this.seen.delete(key);
      }
    }
  }
}
